<hk-base-modal
  (apply)="onAcceptClick()"
  (cancel)="callbacks.onCloseModal()"
  [isApplyPossible]="
    this.inputFormControl.valid &&
    (this.onlyAllowExactMatches ? dataOptions.includes(input?.nativeElement.value) : input?.nativeElement.value)
  "
  [title]="title"
>
  <mat-form-field class="mx-auto w-full pt-2">
    <mat-label *ngIf="label">{{ label }}</mat-label>
    <input
      #options
      (keyup.enter)="keyupEnter()"
      *ngIf="inputType === 'input'"
      [formControl]="inputFormControl"
      [matAutocomplete]="auto"
      [placeholder]="placeholder"
      matInput
      title="text"
      type="text"
    />
    <!--suppress JSUnusedGlobalSymbols -->
    <textarea
      #options
      *ngIf="inputType === 'textarea'"
      [formControl]="inputFormControl"
      [matAutocomplete]="auto"
      cdkTextareaAutosize
      matInput
      title="text"
      type="text"
    ></textarea>
    <button
      (click)="inputFormControl.setValue('')"
      aria-label="Clear"
      class="!bg-transparent"
      data-testid="inputWithClear.clear"
      hk-button-flat
      matTextSuffix
      tabindex="1"
      type="button"
    >
      <i class="ph ph-backspace"></i>
    </button>
    <ng-container *ngIf="inputFormControl.dirty && inputFormControl.invalid">
      <mat-error *ngFor="let error of inputFormControl.errors | keyvalue">
        <mat-error class="error-message">{{ error.value }}</mat-error>
      </mat-error>
    </ng-container>
    <mat-autocomplete #auto="matAutocomplete">
      <mat-option *ngFor="let option of filteredOptions | async" [value]="option">{{ option }}</mat-option>
    </mat-autocomplete>
  </mat-form-field>
</hk-base-modal>
